function checkConditions(actions) {
  // return the actions based on the conditions
  if ("default" in actions) {
    if ("onCondition" in actions) {
      for (let onCondition of actions.onCondition) {
        let check = [];
        Object.entries(onCondition.conditions).forEach(([key, value]) => {
          check.push(this.checkCondition(key, value));
        });
        if (check.every((e) => e === true) && check.length > 0) {
          return onCondition.todo;
        }
      }
    }
    return actions.default;
  }
  return actions;
}

function getLine(actions) {
  console.log("waiting", this.waitingForMo, this.currentLine);
  if (this.currentLine < 0) {
    return "";
  }
  if (actions.constructor === Array) {
    actions = actions[this.currentLine];
  }
  if (actions.constructor === Object) {
    //run narrator audio here
    actions.text = actions.text === "undefined" ? "" : actions.text;
    if ("narrate" in actions) {
      this.$store.commit("setNarrate", actions.narrate);
    }
    return actions.text;
  }
  actions = actions === "undefined" ? "" : actions;
  return actions;
}
function startImidiateActions(actions, runFakeAction) {
  if (actions.constructor === Array) {
    actions = actions[this.currentLine];
  }
  if (actions.constructor === Object) {
    if ("startFakeAction" in actions) {
      //      console.log("start fake action", this.fakeActionMode);
      if (runFakeAction || !this.fakeActionMode) {
        this.$store.commit("startFakeAction", [
          actions.startFakeAction,
          actions.videos,
        ]);
      } else {
        this.$store.commit("prepareFakeAction", [
          actions.startFakeAction,
          actions.videos,
        ]);
      }
    } else if ("changeCamera" in actions) {
      //      console.log("stop fake action and change camera");
      this.$store.commit("stopFakeAction");
      //  this.changeCamera(i.changeCamera);
    }
  }
}
function nextActions(actions) {
  // this.imteraction = actions
  actions = this.checkConditions(actions);

  let _actions = actions;
  if (actions.constructor === Array) {
    actions = actions[this.currentLine];
  }

  let wait = false;
  //Conditions
  if (actions.constructor === Object) {
    if ("setCondition" in actions) {
      this.setCondition(actions.setCondition);
    }
    //Action
    if ("action" in actions) {
      let command = { text: actions.action };
      this.setCommand({ text: ">>clear" });
      this.setCommand(command);
      this.sendCommand();
    }
    //Events
    if ("startEvent" in actions) {
      this.$store.commit("playEvent", this.events[actions.startEvent].video);
      this.$store.commit("mute");
      if ("wait" in this.events[actions.startEvent]) {
        if (this.events[actions.startEvent].wait) {
          this.setCommand({ text: ">>clear" });
          this.setCommand({ text: ">wait:" });
          this.sendCommand();
          this.$store.commit("skip", true);
          wait = true;
        }
      }
    }
    if ("talk" in actions) {
      this.talk(actions.talk);
    }
    //change chapter
    if ("go" in actions) {
      if ("onenter" in this.chapters[actions.go]) {
        //  this.$parent.interaction = this.chapters[this.go].onenter;
        this.$store.commit("setChapter", actions.go);
        this.startAction(this.chapters[actions.go].onenter);
      }
    }
    //take items
    if ("in" in actions) {
      if (Array.isArray(actions.in)) {
        for (let item of actions.in) {
          this.takeItem(item);
        }
      } else {
        this.takeItem(actions.in);
      }
    }
    //remove items
    if ("out" in actions) {
      if (Array.isArray(actions.out)) {
        for (let item of actions.out) {
          this.removeItem(item);
        }
      } else {
        this.removeItem(actions.out);
      }
    }
    if ("text" in actions) {
      this.$store.commit("setLine", actions.text);
      //  wait = true; //Maybe problem
      //  this.$store.commit("waitForMo");
    }
  } else {
    this.$store.commit("setLine", actions);
  }
  if (
    _actions.constructor === Array &&
    _actions.length > this.currentLine + 1
  ) {
    this.$store.commit("nextLine");
  } else {
    if (this.isBrowserGame) {
      this.$store.commit("resetCurrentLine");
    } else {
      this.$store.commit("resetCurrentLine", true);
    }

    this.$store.commit("continue");
  }
  if (!wait) {
    this.continue();
  }
}
export { checkConditions, getLine, startImidiateActions, nextActions };
